module.exports = __webpack_public_path__ + "static/media/banner5.972f6574.jpg";